
import XInput from 'vux/src/components/x-input/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
name: 'TradeStateChart',
components: {
Divider,
XInput,
Checker,
CheckerItem,
Group,
Cell,
Search,
XButton,
Flexbox,
Selector,
Card,
FlexboxItem,
Checklist
},
data () {
return {
toolbox: {
feature: {
magicType: {type: ['line', 'bar', 'pie']}
}
},
queryParams: null,
chartType: 'line',
chartType_list: [{key: 'histogram', value: '柱图'}, {key: 'line', value: '线图'}, {key: 'pie', value: '饼图'}],
dictChartData: {},
chartColumn: [],
groupby_list: [{key: 'COUNTRY', value: '国家'}, {key: 'CODETS', value: '商品'}],
metrics_list: [ {key: 'I_Money', value: '进口金额'}, {key: 'E_Money', value: '出口金额'},
{key: 'I_Number', value: '进口数量'}, {key: 'E_Number', value: '出口数量'},
{key: 'IE', value: '进出口金额'}],
groupby: 'CODETS',
metrics: 'I_Money',
unit_list: [{key: 'Unit_1', value: '第一法定计量单位'}, {key: 'Unit_2', value: '第二法定计量单位'}],
unit: 'Unit_1',
colors: ['#00417b', '#2f4554', '#61a0a8',
'#d48265', '#91c7ae', '#749f83',
'#ca8622', '#bda29a', '#6e7074',
'#546570', '#c4ccd3'],
dataZoom: [
{
type: 'slider',
start: 0,
end: 100
}
],
chartSettings: {
type: 'pie',
legendName: {
'访问用户': '访问用户 total: 10000'
}
},
chartData: {
columns: ['日期', '中国', '美国', '日本'],
rows: [
{'日期': '1/1', '中国': 1393, '美国': 1093, '日本': 1093},
{'日期': '1/2', '中国': 3530, '美国': 3230, '日本': 3230},
{'日期': '1/3', '中国': 2923, '美国': 2623, '日本': 2623},
{'日期': '1/4', '中国': 1723, '美国': 1423, '日本': 1423},
{'日期': '1/5', '中国': 3792, '美国': 3492, '日本': 3492},
{'日期': '1/6', '中国': 4593, '美国': 4293, '日本': 4293}
]
}
}
},
methods: {
buildLegendName: function (queryParams) {
let legend = {}
let groupByArray = this.groupby === 'CODETS' ? queryParams.CodeTS : queryParams.Region
if (!groupByArray) {
return []
}
let self = this
groupByArray.forEach(function (s) {
legend[self.groupby + s.split('$')[0]] = s.split('$')[1]
})
return legend
},
buildChartColumn: function (queryParams) {
let groupByArray = this.groupby === 'CODETS' ? queryParams.CodeTS : queryParams.Region
let self = this
if (!groupByArray) {
return []
}
return ['日期'].concat(groupByArray.map(function (s) {
return self.groupby + s.split('$')[0]
}))
},
chartTypeChange: function () {
if (this.chartType === 'pie') {
this.showPie()
} else {
this.showOther(this.chartType)
}
},
formatForECHART: function () {
let self = this
let ret = []
if (Object.keys(self.dictChartData).length === 0) {
return ret
}
this.chartData.columns = this.buildChartColumn(this.queryParams)
this.chartSettings.legendName = this.buildLegendName(this.queryParams)
Object.keys(self.dictChartData).forEach(function (yearKey) {
let row = {'日期': yearKey}
let yearGroup = self.dictChartData[yearKey]
Object.keys(yearGroup).forEach(function (groupKey) {
if (groupKey.startsWith(self.groupby)) {
row[groupKey] = yearGroup[groupKey][self.metrics + '_' + self.unit]
}
})
ret.push(row)
})
console.log(ret)
this.chartData.rows = ret
},
showPie: function () {
this.chartSettings.columns = this.chartColumn
this.dataZoom = []
this.chartSettings.type = 'pie'
},
showOther: function (itemValue) {
this.chartSettings.columns = this.chartData.columns
this.dataZoom = [{
type: 'slider',
start: 0,
end: 100
}]
this.chartSettings.type = itemValue
}
},
async created () {
this.queryParams = this.$route.params
const queryPromise = await this.$http.post('/API/TradeStat/Stat'
, this.queryParams)
console.log(queryPromise.data)
this.dictChartData = queryPromise.data
this.formatForECHART()
}
}



// WEBPACK FOOTER //
// ./src/components/TradeStateChart.vue